var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-sidebar-attachments-block", {
    attrs: { item: _vm.filesItem, state: _vm.state },
    on: {
      summary: function ($event) {
        return _vm.$emit("summary", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }